import { render, staticRenderFns } from "./refundDetail.vue?vue&type=template&id=42a228a6&scoped=true&"
import script from "./refundDetail.vue?vue&type=script&lang=js&"
export * from "./refundDetail.vue?vue&type=script&lang=js&"
import style0 from "./refundDetail.vue?vue&type=style&index=0&id=42a228a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a228a6",
  null
  
)

export default component.exports